interface NewPasswordStepProps {
  newPassword: string;
  confirmPassword: string;
  isLoading: boolean;
  onNewPasswordChange: (value: string) => void;
  onConfirmPasswordChange: (value: string) => void;
  onSubmit: () => void;
  className?: string;
}

export function NewPasswordStep({ 
  newPassword,
  confirmPassword,
  isLoading,
  onNewPasswordChange, 
  onConfirmPasswordChange,
  onSubmit,
  className = '' 
}: NewPasswordStepProps) {
  
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit();
  };

  const isPasswordValid = newPassword.length >= 8;
  const isPasswordMatch = newPassword === confirmPassword && confirmPassword.length > 0;

  return (
    <form onSubmit={handleSubmit} className={`space-y-6 ${className}`}>
      {/* 안내 메시지 */}
      <div className="text-center text-[14px] text-gray-600 mb-6">
        새로운 비밀번호를 설정해주세요<br />
        안전한 비밀번호를 사용하는 것을 권장합니다
      </div>

      {/* 새 비밀번호 입력 */}
      <div>
        <label className="block text-[16px] font-medium text-[#222222] mb-3">
          새 비밀번호
        </label>
        <input
          type="password"
          value={newPassword}
          onChange={(e) => onNewPasswordChange(e.target.value)}
          placeholder="8자리 이상 입력해주세요"
          className="w-full h-[50px] px-4 text-[16px] border-[1.5px] border-[#DEDEDE] rounded-xl focus:outline-none focus:border-[#51C854] placeholder:text-[#999999]"
        />
        <div className="flex items-center mt-2">
          <div className={`w-3 h-3 rounded-full mr-2 ${
            isPasswordValid ? 'bg-green-500' : 'bg-gray-300'
          }`} />
          <p className={`text-[12px] ${
            isPasswordValid ? 'text-green-600' : 'text-gray-500'
          }`}>
            8자리 이상
          </p>
        </div>
      </div>

      {/* 비밀번호 확인 */}
      <div>
        <label className="block text-[16px] font-medium text-[#222222] mb-3">
          비밀번호 확인
        </label>
        <input
          type="password"
          value={confirmPassword}
          onChange={(e) => onConfirmPasswordChange(e.target.value)}
          placeholder="비밀번호를 다시 입력해주세요"
          className="w-full h-[50px] px-4 text-[16px] border-[1.5px] border-[#DEDEDE] rounded-xl focus:outline-none focus:border-[#51C854] placeholder:text-[#999999]"
        />
        {confirmPassword.length > 0 && (
          <div className="flex items-center mt-2">
            <div className={`w-3 h-3 rounded-full mr-2 ${
              isPasswordMatch ? 'bg-green-500' : 'bg-red-500'
            }`} />
            <p className={`text-[12px] ${
              isPasswordMatch ? 'text-green-600' : 'text-red-600'
            }`}>
              {isPasswordMatch ? '비밀번호가 일치합니다' : '비밀번호가 일치하지 않습니다'}
            </p>
          </div>
        )}
      </div>

      {/* 비밀번호 변경 버튼 */}
      <button
        type="submit"
        disabled={isLoading || !isPasswordValid || !isPasswordMatch}
        className="w-full h-[50px] bg-[#51C854] text-white font-semibold text-[16px] rounded-xl hover:bg-[#46B649] disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors"
      >
        {isLoading ? '변경 중...' : '비밀번호 변경'}
      </button>

      {/* 보안 안내 */}
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 text-center">
        <p className="text-[12px] text-blue-700">
          <strong>보안 팁:</strong> 영문, 숫자, 특수문자를 조합하여<br />
          더욱 안전한 비밀번호를 만들어보세요
        </p>
      </div>
    </form>
  );
}